// Returns a list of category ids, that has links in them
export const getCategoryIdsWithLinks = (links) => {
  const categoryIds = links
    .flatMap((link) => link.entityContent.categories)
    .map((category) => category.id);

  return Array.from(new Set(categoryIds));
};
